/**
 * SPEC-008 §69/plan §28 — presentation-only formatting. Unknown is always
 * "—", never "0" (a real zero renders as "0"/"0%"/"R$ 0,00").
 */
export function formatUnknown(): string {
  return '—';
}

export function formatMoneyMinorUnits(value: number | null): string {
  if (value === null) return formatUnknown();
  return (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatRatioAsPercent(value: number | null, fractionDigits = 1): string {
  if (value === null) return formatUnknown();
  return `${(value * 100).toFixed(fractionDigits)}%`;
}

export function formatCount(value: number | null): string {
  if (value === null) return formatUnknown();
  return Math.round(value).toLocaleString('pt-BR');
}

export function formatDecimal(value: number | null, fractionDigits = 2): string {
  if (value === null) return formatUnknown();
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: fractionDigits });
}
